<template>
    <div class="pay">

      <div class="pay-price">
        <h3>￥{{ price }}</h3>
        <span class="time"><span>支付剩余时间：</span><van-count-down :time="time" /></span>
      </div>

      <div class="pay-type">
        <van-radio-group v-model="payRadio">
          <van-cell-group>
            <van-cell title="微信支付" clickable @click="payRadio='1'" v-show="wxShow">
              <template #right-icon>
                <van-radio name="1" />
              </template>
            </van-cell>
            <van-cell :title="`余额支付 `+userInfo.balance" clickable @click="payRadio='3'">
              <template #right-icon>
                <van-radio name="3" />
              </template>
            </van-cell>
            <van-cell title="线下打款" clickable @click="payRadio='2'" v-show="gradeShow">
              <template #right-icon>
                <van-radio name="2" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
      <div class="pay-company" v-show="gradeShow">线下打款：是以向总部打款方式付款，付款完成后总部会在第一时间与您核实信息</div>
      <div class="pay-btn">
        <van-button round type="primary" block @click="callPay">确认支付</van-button>
      </div>
      <Floating />
      <wxNoShare />
    </div>
</template>
<script>
  import { RadioGroup, Radio, Cell, CellGroup, CountDown, Button,Dialog } from 'vant'
  import wx from 'weixin-jsapi'

  export default {
    components: {
      [Button.name]: Button,
      [CellGroup.name]: CellGroup,
      [Cell.name]: Cell,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [CountDown.name]: CountDown,
      [Dialog.Component.name]: Dialog.Component
    },
    name: 'pay',
    data() {
      return {
        payRadio: '1',
        time: 0,
        price: '',
        order_no: '',
        members_grade_id: 4,
        gradeShow: false,
        wxShow: true,
        userInfo: {balance:0}
      };
    },
    created() {
      this.getUser()
      this.$api.get('payments/pay', {id:this.$route.query.id}, r=>{
        this.order_no = r.data.order_no
        this.price = r.data.pay_price
        this.members_grade_id = r.data.members_grade_id
        this.time = (24 - r.data.residue_time) * 60 * 60 * 1000
        if(r.data.members_grade_id == 1) {
          this.gradeShow = true
          this.wxShow = false
          this.payRadio = '2'
        }
      })
    },
    methods: {
      getUser() {
        this.$api.get('user', null, r=>{
          this.userInfo = r.data
        })
      },
      callPay() {
        if(this.payRadio == 3){
          if(Number(this.userInfo.balance) < Number(this.price)){
            this.$toast('余额不足，请选择其他支付方式')
            return;
          }else{
            this.$api.post('payments/balance', {order_no: this.order_no}, r=>{
              if(r.success === 1){
                this.$toast('支付成功')
                this.$router.push({name: 'paymentSucceed', query: {id: this.$route.query.id}})
              }else{
                this.$toast('支付失败')
                return;
              }
            })
          }
        }else if(this.payRadio == 2){
          Dialog.alert({
            message: '线下打款，总部工作人员会与你联系进行付款，请保持手机畅通！',
          }).then(() => {
            this.$router.push({name: 'orders'})
          })
        }else{
          if (typeof WeixinJSBridge == "undefined"){
            if( document.addEventListener ){
              document.addEventListener('WeixinJSBridgeReady', this.jsApiCall(), false);
            }else if (document.attachEvent){
              document.attachEvent('WeixinJSBridgeReady', this.jsApiCall());
              document.attachEvent('onWeixinJSBridgeReady', this.jsApiCall());
            }
          }else{
            this.jsApiCall();
          }
        }
      },
      jsApiCall() {
        let self = this
        this.$api.post('payments/wxConfig',{order_no:this.order_no}, r=>{
          var data = r.data
          window.WeixinJSBridge.invoke(
            'getBrandWCPayRequest',{appId:data.appId, timeStamp: data.timeStamp, nonceStr: data.nonceStr, package: data.package, signType: data.signType, paySign: data.paySign,},
            function(res){
              //console.log(res)
              if (res.err_msg == "get_brand_wcpay_request:ok") { // 支付成功
                //window.location.href="/users/index";
                window.location.href = "/payment/succeed?id="+self.$route.query.id
                //self.$router.push({name:'paymentSucceed', query:{id:self.$route.query.id}})
                return
              }
              if(res.err_msg == "get_brand_wcpay_request:fail") { // 支付失败
                this.$toast('支付失败');
              }
              if (res.err_msg == "get_brand_wcpay_request:cancel") { // 取消支付
                this.$toast('取消支付');
              }
            }
          )
        })
      }
    }
  }
</script>

<style scoped>
  .pay{
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    position: fixed;
    overflow: hidden;
  }
  .pay-price{
    text-align: center;
  }
  .pay-price h3{
    font-size: 36px;
    font-weight: normal;
    margin: 15% 0 5%;
  }
  .pay-price .time{
    display: inline-block;
    font-size: 14px;
    background: #F3F3F3;
    border-radius: 5px;
    padding:3px 5px;
    margin-bottom: 10%;
  }
  .pay-price .time span{
    float: left;
  }
  .pay-price .time div{
    float: left;
  }
  .pay-type{
    overflow: hidden;
    padding:0 15px;
  }
  .pay-type .img-icon{
    width: 40px;
    float: left;
  }
  .pay-company{
    font-size: 12px;
    padding:5px 30px;
    color: #a8a8a8;
    line-height: 20px;
  }
  .pay-btn{
    text-align: center;
    margin-top: 10%;
    padding:0 35px;
  }
  .pay-btn button{
    padding:0 60px;
  }
</style>



// WEBPACK FOOTER //
// src/views/payment/pay.vue